import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import biomeApi from '../biome.api';
import { useNavigate, useParams } from 'react-router-dom';
import {
    fetchBiomeAdventureApi,
    removeBiomeAdventureItem,
    editAdventureQty,
    cancelEditAdventureQty,
    updateAdventureQty,
    updateAdventureQtyApi,
} from '../biomeSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faPencil, faSave } from '@fortawesome/free-solid-svg-icons';
import Datatable from '~/components/Datatable';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
const MySwal = withReactContent(Swal);
import { handleThunkException } from '~/services/thunk.service';
import BiomeInfo from './BiomeInfo';
import AdventureFilter from './AdventureFilter';
import InlineEditingCell from '~/components/Datatable/InlineEditingCell';
import cloneDeep from 'lodash/cloneDeep';

function BiomeUpdate() {
    // Get ID from URL
    const params = useParams();
    const biomeId = params.id;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [keyAsyncSelect, setKeyAsyncSelect] = useState(0);
    const { adventureRows, editedAdventureRow } = useSelector((state) => state.cardSaga.biome);
    const handleChange = (e, row, fieldName) => {
        const re = /^[0-9\b]+$/;
        // enforce digit only
        if (e.target.value === '' || re.test(e.target.value)) {
            row[fieldName] = parseInt(e.target.value);
            dispatch(updateAdventureQty(row));
        }
    };

    const columns = [
        {
            name: '#',
            selector: (row) => row.id,
            sortable: true,
        },
        {
            name: 'Adventure Name',
            selector: (row) => row.adventure_name,
            sortable: true,
        },
        {
            name: 'Quantity',
            selector: (row) => row.qty,
            sortable: true,
            cell: (row) => (
                <InlineEditingCell
                    row={row}
                    editedRow={editedAdventureRow}
                    handleChange={handleChange}
                    fieldName="qty"
                    tag="input"
                />
            ),
        },
        {
            name: 'Edit Quantity',
            cell: (row) => {
                if (row.id !== editedAdventureRow.id) {
                    return (
                        <Button
                            size="sm"
                            className={'bg-info border border-info'}
                            onClick={() => {
                                dispatch(editAdventureQty(row));
                            }}
                        >
                            <FontAwesomeIcon icon={faPencil} />
                        </Button>
                    );
                } else {
                    return (
                        <>
                            <Button
                                size="sm"
                                className={'bg-warning border border-warning mr-2'}
                                onClick={() => {
                                    dispatch(cancelEditAdventureQty());
                                }}
                            >
                                <FontAwesomeIcon icon={faXmark} />
                            </Button>
                            <Button
                                size="sm"
                                className={'bg-success border border-success'}
                                onClick={() => {
                                    dispatch(updateAdventureQtyApi({ biomeId, navigate }));
                                }}
                            >
                                <FontAwesomeIcon icon={faSave} />
                            </Button>
                        </>
                    );
                }
            },
        },
        {
            name: 'Delete',
            selector: (row) => row.biome_name,
            cell: (row) => (
                <Button
                    size="sm"
                    className={'bg-danger border border-danger'}
                    onClick={async () => {
                        try {
                            MySwal.fire({
                                title: 'Are you sure?',
                                text: "You won't be able to revert this!",
                                icon: 'warning',
                                confirmButtonColor: '#d33',
                            }).then(async (result) => {
                                if (result.isConfirmed) {
                                    await biomeApi.removeAdventure(biomeId, row.id);
                                    dispatch(removeBiomeAdventureItem(row.id));
                                    setKeyAsyncSelect(keyAsyncSelect + 1);
                                }
                            });
                        } catch (error) {
                            handleThunkException(error, dispatch, navigate);
                        }
                    }}
                >
                    <FontAwesomeIcon icon={faXmark} />
                </Button>
            ),
        },
    ];

    useEffect(() => {
        dispatch(fetchBiomeAdventureApi({ navigate, id: biomeId }));
    }, []);

    return (
        <>
            <BiomeInfo />
            <Card>
                <Card.Body>
                    <Row sm={12}>
                        <Col>
                            <h4>Adventure Card</h4>
                            <Card>
                                <AdventureFilter
                                    setKeyAsyncSelect={setKeyAsyncSelect}
                                    keyAsyncSelect={keyAsyncSelect}
                                />
                                <div className="col-sm-6 offset-sm-3">
                                    <Datatable
                                        columns={columns}
                                        rows={cloneDeep(adventureRows)}
                                    />
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </>
    );
}

export default BiomeUpdate;
